import CartAPI from "@/app/apis/main/cart/cart-api.js"

export default {
	/**
	 * @param petId
	 * @return {object} cart list
	 */
	async getCart(petId, cartDetails) {
		return CartAPI.getCart(petId, cartDetails)
	},
	
	async getPublicCartProductDetails(bundleIds) {
		return CartAPI.getPublicCartProductDetails(bundleIds)
	},

	/**
	 * @param petId
	 * @return {*} cart counnt
	 */
	async getCartCount(petId, cartDetails) {
		return CartAPI.getCartCount(petId, cartDetails)
	},

	/**
	 * @param petId
	 * @param bundleIds
	 * @return {object} No content
	 */
	async deleteCart(petId, bundleIds) {
		return CartAPI.deleteCart(petId, bundleIds)
	},

	/**
	 * @param petId
	 * @param bundleId
	 * @param cartDetails
	 * @return {object} No content
	 */
	async putCart(petId, cartDetails) {
		return CartAPI.putCart(petId, cartDetails)
	},

	/**
	 * @param petId
	 * @param bundleId
	 * @param cartDetails
	 * @return {object} No content
	 */
	async postCart(petId, cartDetails) {
		return CartAPI.postCart(petId, cartDetails)
	},

	/**
	 * @param bundleId
	 * @return {object} No content
	 */
	async deleteDogCart(bundleId) {
		return CartAPI.deleteDogCart(bundleId)
	},
}
